module.exports = __webpack_public_path__ + "32dc4ba1c73428fdf0fcea367a944107.jpg";